export enum Experiments {
  PrivateMemberIndicator = 'specs.membersArea.PrivateMemberIndicator',
  UiTpaImage = 'specs.profileCardOOI.imgMigration',
  PopoverAndTooltipMigration = 'specs.profileCardOOI.popoverTooltipMigration',
}
